// import { createTheme } from '@mui/material/styles';

// const myTheme = createTheme({
// 	palette: {
// 		primary: {
// 			main: '#CD3131',
// 			// Removed invalid 'light' value – must be a color, not box-shadow
// 			// Use shadow in component style if needed
// 			// light: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);',
// 		},
// 		secondary: {
// 			main: '#44566C',
// 			light: '#42a5f5',
// 			dark: '#1565c0',
// 			contrastText: '#fff',
// 		},
// 		error: {
// 			main: '#d32f2f',
// 			light: '#e57373',
// 			dark: '#c62828',
// 			contrastText: '#fff',
// 		},
// 		warning: {
// 			main: '#1976d2',
// 			light: '#42a5f5',
// 			dark: '#1565c0',
// 			contrastText: '#fff',
// 		},
// 		info: {
// 			main: '#000',
// 			light: '#42a5f5',
// 			dark: '#CD3131',
// 			contrastText: '#000',
// 		},
// 		success: {
// 			main: '#CD3131',
// 			light: '#42a5f5',
// 			dark: '#228a51',
// 			contrastText: '#fff',
// 		},
// 		action: {
// 			active: '#CD3131',
// 			hover: '#CD3131',
// 			hoverOpacity: 0.04,
// 			selected: 'rgb(193, 0, 0)',
// 			selectedOpacity: 0.08,
// 			disabled: 'rgba(0, 0, 0, 0.26)',
// 			disabledBackground: 'rgba(0, 0, 0, 0.12)',
// 			disabledOpacity: 0.38,
// 			focus: 'rgba(0, 0, 0, 0.12)',
// 			focusOpacity: 0.12,
// 			activatedOpacity: 0.12,
// 		},
// 		text: {
// 			primary: '#000000',
// 			secondary: '#44566C',
// 			disabled: '#4D4D4D',
// 		},
// 	},
// 	//   components: {
// 	//     MuiButton: {
// 	//       styleOverrides: {
// 	//         root: {
// 	//           fontWeight: 400,
// 	//           fontSize: '12px',
// 	//           lineHeight: '13.56px',
// 	//           letterSpacing: '0%',
// 	//           textAlign: 'center',
// 	//           verticalAlign: 'middle',
// 	//           textTransform: 'capitalize',
// 	//           borderRadius: '19.38px',
// 	//           padding: '12px 24px', // removed trailing semicolon
// 	//         },
// 	//       },
// 	//     },
// 	//     MuiTab: {
// 	//       styleOverrides: {
// 	//         root: {
// 	//           border: '1px solid',
// 	//           borderRadius: '19.38px',
// 	//           padding: '12px 24px',
// 	//           marginRight: '8px', // spacing(1) is roughly 8px
// 	//           '&.Mui-selected': {
// 	//             backgroundColor: '#CD3131',
// 	//             color: '#fff',
// 	//             borderColor: '#CD3131',
// 	//           },
// 	//           '&:hover': {
// 	//             backgroundColor: '#CD3131',
// 	//             color: '#fff',
// 	//           },
// 	//         },
// 	//       },
// 	//     },
// 	//   },
// 	components: {
// 		MuiButton: {
// 			styleOverrides: {
// 				root: {
// 					fontWeight: 400,
// 					fontSize: '14px',
// 					lineHeight: '13.56px',
// 					letterSpacing: '0%',
// 					textAlign: 'center',
// 					verticalAlign: 'middle',
// 					textTransform: 'capitalize',
// 					borderRadius: '20px',
// 					padding: '12px 24px',
// 					transition: 'all 0.4s ease-in, 0.6s ease-out',
// 				},
// 			},
// 		},
// 		// MuiTab: {
// 		// 	styleOverrides: {
// 		// 		root: {
// 		// 			border: '1px solid',
// 		// 			borderColor: '#CD3131',
// 		// 			color: '#CD3131',
// 		// 			borderRadius: '19.38px',
// 		// 			padding: '6px 14px',
// 		// 			marginRight: '8px',
// 		// 			minHeight: '36px',
// 		// 			fontSize: '12px',
// 		// 			textTransform: 'none',
// 		// 			'&.Mui-selected': {
// 		// 				backgroundColor: '#CD3131',
// 		// 				color: '#fff',
// 		// 				borderColor: '#CD3131',
// 		// 			},
// 		// 			'&:hover': {
// 		// 				backgroundColor: '#CD3131',
// 		// 				color: '#fff',
// 		// 			},
// 		// 		},
// 		// 	},
// 		// },
// 		MuiTab: {
// 			styleOverrides: {
// 				root: {
// 					border: '1px solid',
// 					borderColor: '#CD3131',
// 					color: '#CD3131',
// 					borderRadius: '19.38px',
// 					padding: '6px 14px',
// 					marginRight: '8px',
// 					minHeight: '36px',
// 					fontSize: '12px',
// 					textTransform: 'none',
// 					transition: 'all 0.4s ease-in, 0.6s ease-out',
// 					'&.Mui-selected': {
// 						backgroundColor: '#CD3131',
// 						color: '#fff',
// 						borderColor: '#CD3131',
// 					},
// 					'&:hover': {
// 						backgroundColor: '#CD3131',
// 						color: '#fff',
// 					},
// 				},
// 			},
// 		},

// 		MuiTabs: {
// 			styleOverrides: {
// 				indicator: {
// 					display: 'none', // ✅ Hides the bottom line under selected tab
// 				},
// 			},
// 		},
// 	},
// 	typography: {
// 		fontFamily: 'poppins, sans-serif',
// 		h1: {
// 			fontSize: '36px',
// 			fontWeight: 'bold',
// 			lineHeight: 1.2,
// 			letterSpacing: '0.02em',
// 		},
// 		h2: {
// 			fontSize: '30px',
// 			fontWeight: 'bold',
// 			lineHeight: 1.3,
// 			letterSpacing: '0.02em',
// 		},
// 		h3: {
// 			fontSize: '24px',
// 			fontWeight: '700', // Semi-bold
// 			lineHeight: 1.4,
// 		},
// 		h4: {
// 			fontSize: '20px',
// 			fontWeight: '700', // Medium weight
// 			lineHeight: 1.5,
// 		},
// 		h5: {
// 			fontSize: '18px',
// 			fontWeight: '400', // Normal weight
// 			lineHeight: 1.6,
// 		},
// 		h6: {
// 			fontSize: '16px',
// 			fontWeight: '400',
// 			lineHeight: 1.6,
// 		},
// 		subtitle1: {
// 			fontSize: '16px',
// 			fontWeight: '500',
// 			lineHeight: 1.5,
// 		},
// 		subtitle2: {
// 			fontSize: '14px',
// 			fontWeight: '400',
// 			// fontWeight: '300',
// 			lineHeight: 1.5,
// 		},
// 		body1: {
// 			fontSize: '16px',
// 			fontWeight: 'normal',
// 			lineHeight: 1.6,
// 		},
// 		body2: {
// 			fontSize: '14px',
// 			fontWeight: 'normal',
// 			lineHeight: 1.6,
// 		},
// 	},
// });

// export default myTheme;
// ======================================================================================================
// ======================================================================================================
// ======================================================================================================
// ======================================================================================================
// ======================================================================================================
// ======================================================================================================
// ======================================================================================================
// ======================================================================================================
// ======================================================================================================
// ======================================================================================================
// ======================================================================================================
// ======================================================================================================
// ======================================================================================================
// ======================================================================================================
import { createTheme } from '@mui/material/styles';

const myTheme = createTheme({
	palette: {
		primary: {
			main: '#CD3131',
			// Removed invalid 'light' value – must be a color, not box-shadow
			// Use shadow in component style if needed
			// light: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);',
		},
		secondary: {
			main: '#44566C',
			light: '#42a5f5',
			dark: '#1565c0',
			contrastText: '#fff',
		},
		error: {
			main: '#d32f2f',
			light: '#e57373',
			dark: '#c62828',
			contrastText: '#fff',
		},
		warning: {
			main: '#1976d2',
			light: '#42a5f5',
			dark: '#1565c0',
			contrastText: '#fff',
		},
		info: {
			main: '#000',
			light: '#42a5f5',
			dark: '#CD3131',
			contrastText: '#000',
		},
		success: {
			main: '#CD3131',
			light: '#42a5f5',
			dark: '#228a51',
			contrastText: '#fff',
		},
		action: {
			active: '#CD3131',
			hover: '#CD3131',
			hoverOpacity: 0.04,
			selected: 'rgb(193, 0, 0)',
			selectedOpacity: 0.08,
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(0, 0, 0, 0.12)',
			disabledOpacity: 0.38,
			focus: 'rgba(0, 0, 0, 0.12)',
			focusOpacity: 0.12,
			activatedOpacity: 0.12,
		},
		text: {
			primary: '#000000',
			secondary: '#44566C',
			disabled: '#4D4D4D',
		},
	},
	//   components: {
	//     MuiButton: {
	//       styleOverrides: {
	//         root: {
	//           fontWeight: 400,
	//           fontSize: '12px',
	//           lineHeight: '13.56px',
	//           letterSpacing: '0%',
	//           textAlign: 'center',
	//           verticalAlign: 'middle',
	//           textTransform: 'capitalize',
	//           borderRadius: '19.38px',
	//           padding: '12px 24px', // removed trailing semicolon
	//         },
	//       },
	//     },
	//     MuiTab: {
	//       styleOverrides: {
	//         root: {
	//           border: '1px solid',
	//           borderRadius: '19.38px',
	//           padding: '12px 24px',
	//           marginRight: '8px', // spacing(1) is roughly 8px
	//           '&.Mui-selected': {
	//             backgroundColor: '#CD3131',
	//             color: '#fff',
	//             borderColor: '#CD3131',
	//           },
	//           '&:hover': {
	//             backgroundColor: '#CD3131',
	//             color: '#fff',
	//           },
	//         },
	//       },
	//     },
	//   },
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					fontWeight: 400,
					fontSize: '14px',
					lineHeight: '13.56px',
					letterSpacing: '0%',
					textAlign: 'center',
					verticalAlign: 'middle',
					textTransform: 'capitalize',
					borderRadius: '20px',
					padding: '12px 24px',
					transition: 'all 0.4s ease-in, 0.6s ease-out',
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				root: {
					border: '1px solid',
					borderColor: '#CD3131',
					color: '#CD3131',
					borderRadius: '19.38px',
					padding: '6px 14px',
					marginRight: '8px',
					minHeight: '36px',
					fontSize: '12px',
					textTransform: 'none',
					transition: 'all 0.4s ease-in, 0.6s ease-out',
					'&.Mui-selected': {
						backgroundColor: '#CD3131',
						color: '#fff',
						borderColor: '#CD3131',
					},
					'&:hover': {
						backgroundColor: '#CD3131',
						color: '#fff',
					},
				},
			},
		},

		MuiTabs: {
			styleOverrides: {
				indicator: {
					display: 'none', // ✅ Hides the bottom line under selected tab
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					// borderRadius: '20px',
					backgroundColor: '#fff',
					'&:hover .MuiOutlinedInput-notchedOutline': {
						// borderColor: '#CD3131',
					},
					'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
						// borderColor: '#CD3131',
						borderWidth: '2px',
					},
				},
				input: {
					// padding: '12px 16px',
					fontSize: '14px',
				},
				notchedOutline: {
					borderColor: '#ccc',
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				root: {
					fontSize: '16px',
					color: '#44566C',
				},
			},
		},
	},
	typography: {
		fontFamily: 'poppins, sans-serif',
		h1: {
			fontSize: '36px',
			fontWeight: 'bold',
			lineHeight: 1.2,
			letterSpacing: '0.02em',
		},
		h2: {
			fontSize: '30px',
			fontWeight: 'bold',
			lineHeight: 1.3,
			letterSpacing: '0.02em',
		},
		h3: {
			fontSize: '24px',
			fontWeight: '700', // Semi-bold
			lineHeight: 1.4,
		},
		h4: {
			fontSize: '20px',
			fontWeight: '700', // Medium weight
			lineHeight: 1.5,
		},
		h5: {
			fontSize: '18px',
			fontWeight: '400', // Normal weight
			lineHeight: 1.6,
		},
		h6: {
			fontSize: '16px',
			fontWeight: '400',
			lineHeight: 1.6,
		},
		subtitle1: {
			fontSize: '16px',
			fontWeight: '500',
			lineHeight: 1.5,
		},
		subtitle2: {
			fontSize: '14px',
			fontWeight: '400',
			// fontWeight: '300',
			lineHeight: 1.5,
		},
		body1: {
			fontSize: '16px',
			fontWeight: 'normal',
			lineHeight: 1.6,
		},
		body2: {
			fontSize: '14px',
			fontWeight: 'normal',
			lineHeight: 1.6,
		},
	},
});

export default myTheme;
